import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '../../api.service';
import {RegionCode} from '../regions/region.model';
import {InstanceType} from './instance-type.model';

@Injectable({
  providedIn: 'root'
})
export class InstanceTypesService {

  constructor(
    private readonly apiService: ApiService
  ) {
  }

  public getClusterInstanceTypes(region: RegionCode): Observable<InstanceType[]> {
    return this.apiService.get(`/account/instance-types/clusters/${region}`);
  }

  public getProductionInstanceTypes(region: RegionCode): Observable<InstanceType[]> {
    return this.apiService.get(`/account/instance-types/production-instances/${region}`);
  }
}
